import clsx from "clsx";
import React from "react";
import { useDispatch } from "react-redux";
import { menuAction } from "../../state/ducks/menu";

export interface MenuProps extends React.HTMLAttributes<HTMLUListElement> {
  mode?: "vertical" | "horizontal" | "inline";
  defaultOpenKeys?: string[];
  defaultSelectedKey?: string;
}

export const Menu: React.FC<MenuProps> = (props) => {
  const {
    children,
    mode,
    defaultOpenKeys = [],
    defaultSelectedKey = "",
    className,
    ...other
  } = props;

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      menuAction({
        openingDatakeys: defaultOpenKeys,
        selectedDatakey: defaultSelectedKey,
      })
    );
  }, [defaultOpenKeys, defaultSelectedKey, dispatch]);

  return (
    <ul className={clsx(`menu`, className)} {...other}>
      {children}
    </ul>
  );
};
